<template>
    <div>
        <rkm-data-table
            :fields="fields"
            :repository="repositories.baixa"
            sort-by="descricao"
            search-by="descricao"
        >
            <template v-slot:cell(isAtivo)="{ item }">
                {{ item.isAtivo ? 'ATIVO' : 'INATIVO' }}
            </template>

            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    @click.stop="$refs.ModalMaterial.open(item)"
                    authorize="store-almoxarifado-baixa"
                    color="primary"
                    small
                    title="Cadastrar baixa"
                >
                    <rkm-icon icon="plus" />
                </rkm-button>

                <rkm-button
                    @click.stop="$refs.ModalHistorico.open(item)"
                    authorize="reverse-almoxarifado-baixa"
                    color="primary"
                    small
                    title="Histórico de baixa"
                >
                    <rkm-icon icon="history" />
                </rkm-button>
            </template>
        </rkm-data-table>

        <ModalMaterial ref="ModalMaterial" />
        <ModalHistorico ref="ModalHistorico" />
    </div>
</template>

<script>
// Components.
import ModalMaterial from './components/material/Modal'
import ModalHistorico from './components/historico/Modal'

// Mixins.
import { repository, formats } from '@/mixins'

export default {
    components: { ModalMaterial, ModalHistorico },
    created() {

        this.repositories = {
            baixa: this.getConectaSusRepository('almoxarifado.baixa')
        }
    },
    computed: {
        fields() {

            return [
                {
                    name: 'cadastroMaterial.codigoMaterial',
                    key: 'codigoMaterial',
                    label: 'Código do material',
                    class: 'col-min',
                    searchable: true,
                    sortable: true
                },
                {
                    name: 'descricao',
                    key: 'descricao',
                    label: 'Descrição',
                    searchable: true,
                    sortable: true
                },
                {
                    name: 'cadastroGrupo.nome',
                    key: 'grupo',
                    label: 'Grupo',
                    searchable: true,
                    sortable: true
                },
                {
                    name: 'cadastroSubgrupo.nome',
                    key: 'subgrupo',
                    label: 'Subgrupo',
                    searchable: true,
                    sortable: true
                },
                {
                    name: 'cadastroMaterial.isAtivo',
                    key: 'isAtivo',
                    label: 'Status',
                    class: 'col-min',
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min'
                },
                {
                    name: 'almoxarifadoEntradaItem.codigoBarras',
                    key: 'codigoBarras',
                    label: 'Código de Barras',
                    searchable: true,
                    visible: false,
                },
            ]
        }
    },
    mixins: [ repository, formats ],
}
</script>